import React from "react";
import {signOut} from "firebase/auth";
import {auth} from "../../../config/firebase";
import {
  Avatar,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography, useMediaQuery
} from "@mui/material";
import {
  IconBell,
  IconCreditCard,
  IconLogout,
  IconSettings,
  IconUser,
  IconUserCog,
  IconWallet
} from "@tabler/icons-react";
import {Link, useNavigate} from "react-router-dom";

export const SettingsItem = ({handleClose}) => {
  const [menuPosition, setMenuPosition] = React.useState(null);
  const navigate = useNavigate();

  const handleOpenUserMenu = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setMenuPosition({
      top: rect.top,
      left: rect.left + 56,
    });
  };
  const handleCloseUserMenu = () => {
    setMenuPosition(null);
  };

  const logoutHandle = async () => {
    try {
      await signOut(auth);
      navigate("/");
      handleCloseUserMenu();
      handleClose();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <ListItemButton
        onClick={handleOpenUserMenu}
        className={"text-grey nav-item-btn"}
        sx={{ py: 1.5, borderRadius: 4, minWidth: "0 !important" }}
      >
        <ListItemIcon sx={{ minWidth: "0 !important" }}><IconSettings /></ListItemIcon>
        <ListItemText primary={"Settings"} sx={{ pl: 1.5, display: "none" }} className={"nav-item-text"}
                      primaryTypographyProps={{ sx: { fontSize: 16 } }} />
      </ListItemButton>
      <Menu
        open={Boolean(menuPosition)}
        onClose={handleCloseUserMenu}
        anchorReference="anchorPosition"
        anchorPosition={menuPosition ? { top: menuPosition.top, left: menuPosition.left } : undefined}
        sx={{ zIndex: 99999 }}
        slotProps={{
          paper: {
            sx: { borderRadius: 5, boxShadow: 3, position: 'fixed', marginBottom: "100px" } // Optional: fixed positioning
          }
        }}
        MenuListProps={{
          sx: { minWidth: 240 } // or any fixed width
        }}
      >
        <Stack
          direction={"row"} gap={1} alignItems={"center"}
          sx={{
            px: 2, py: 1.5,
          }}
        >
          <Avatar alt="Remy Sharp" size={"small"} sx={{bgcolor: "#D55380"}} src={auth?.currentUser?.photoURL}/>
          <Typography fontWeight={"bold"}>{auth?.currentUser?.displayName || auth?.currentUser?.email}</Typography>
        </Stack>
        <Divider/>
        <MenuItem component={Link} to={`/view-profile`} onClick={handleClose}
                  sx={{px: 2, py: 1.5, fontSize: "0.75rem"}}>
          <ListItemIcon><IconUser/></ListItemIcon>
          <ListItemText primary={"View Profile"} primaryTypographyProps={{sx: {fontSize: 15}}}/>
        </MenuItem>
        <MenuItem component={Link} to={"/connect-wallet"} onClick={handleClose}
                  sx={{px: 2, py: 1.5, fontSize: "0.75rem"}}>
          <ListItemIcon><IconWallet/></ListItemIcon>
          <ListItemText primary={"Connect wallet"} primaryTypographyProps={{sx: {fontSize: 15}}}/>
        </MenuItem>
        <MenuItem component={Link} to={"/payment-settings"} onClick={handleClose}
                  sx={{px: 2, py: 1.5, fontSize: "0.75rem"}}>
          <ListItemIcon><IconCreditCard/></ListItemIcon>
          <ListItemText primary={"Payment Settings"} primaryTypographyProps={{sx: {fontSize: 15}}}/>
        </MenuItem>
        <MenuItem component={Link} to={"/notifications"} onClick={handleClose}
                  sx={{px: 2, py: 1.5, fontSize: "0.75rem"}}>
          <ListItemIcon><IconBell/></ListItemIcon>
          <ListItemText primary={"Notifications"} primaryTypographyProps={{sx: {fontSize: 15}}}/>
        </MenuItem>
        <MenuItem component={Link} to={"/account-settings"} onClick={handleClose}
                  sx={{px: 2, py: 1.5, fontSize: "0.75rem"}}>
          <ListItemIcon><IconUserCog/></ListItemIcon>
          <ListItemText primary={"Account settings"} primaryTypographyProps={{sx: {fontSize: 15}}}/>
        </MenuItem>
        <Divider/>
        <MenuItem onClick={logoutHandle} sx={{px: 2, py: 1.5, fontSize: "0.75rem"}}>
          <ListItemIcon><IconLogout/></ListItemIcon>
          <ListItemText primary={"Logout"} primaryTypographyProps={{sx: {fontSize: 15}}}/>
        </MenuItem>
      </Menu>
    </>
  )
}
